<template>
    <v-app>
        <v-navigation-drawer v-model="drawer" app>
            <!--  -->

            <lateral-menu />
        </v-navigation-drawer>

        <v-app-bar app>
            <v-row>
                <v-col>
                    <v-app-bar-nav-icon @click.stop="drawer = !drawer">
                    </v-app-bar-nav-icon>
                </v-col>
                <v-col class="text-right">
                    <v-btn v-if="user != null && user.role == 'Admin'" :loading="loading" :disabled="loading" color="yellow"
                        @click="riscaricaTutto()">
                        Download ALL
                    </v-btn>
                </v-col>
            </v-row>
        </v-app-bar>

        <!-- Sizes your content based upon application components -->
        <v-main>
            <!-- Provides the application the proper gutter -->
            <v-container fluid>
                <!-- If using vue-router -->
                <router-view></router-view>
            </v-container>
            <v-fab-transition>
                <v-btn key="mdi-chevron-up" color="primary" fab small dark bottom right class="v-btn-custom"
                    @click="$vuetify.goTo(0, options)">
                    <v-icon>mdi-chevron-up</v-icon>
                </v-btn>
            </v-fab-transition>
        </v-main>

        <v-footer app>
            <!-- -->
        </v-footer>
    </v-app>
</template>
<style scoped>
.v-btn-custom {
    bottom: 0;
    right: 16px;
    position: fixed;
    margin: 0 0 16px 16px;
    z-index: 10;
}
</style>
<script>
import LateralMenu from "../components/LateralMenu.vue";
import requests from "../requests";
export default {
    components: { LateralMenu },
    name: "DefaultTemplate",
    watch: {
        group() {
            this.drawer = false;
        },
    },
    data: () => {
        return {
            drawer: true,
            group: null,
            user: null,
            loading: false,
        };
    },
    computed: {
        options() {
            return {
                duration: 1000,
                offset: 0,
                easing: "easeInOutCubic",
            };
        },
    },
    mounted() {
        this.user = window.currentUser;
    },
    methods: {
        riscaricaTutto() {
            if (window.confirm('sei sicuro?')) {
                if (window.confirm('Sicuro sicuro?!')) {
                    this.loading = true;
                    requests.downloadAll().then(res => {
                        this.loading = false;
                    });
                }
            }
        }
    }
};
</script>
